export default "__VITE_ASSET__BornMOPw__"